
/**
 * @fileoverview A function for validating a given Facebook brand page ID.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */
import Uri from 'goog:goog.Uri';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {useFetch} from '/src/com/yext/listingslaunchstorm/js/common/hooks/usefetch';
import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {getTestCases} from '/src/com/yext/listingslaunchstorm/js/common/util/gettestcases';
import {mockRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/mockrequest';
import {ValidateFacebookBrandResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/validatefacebookbrandresponse';
import {mockValidateFacebookBrandsResponse, mockValidateFacebookBrandsResponseInvalid} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/mocks/mocks';

/**
 *  @param {string=} testCase
  * @return {{
  *   status: (string | undefined),
  *   data: (ValidateFacebookBrandResponse | undefined),
  *   refetch: function(number, string=, string=),
  *   abort: function(),
  * }}
  */
export function useValidateFacebookBrand(testCase='') {
  const {status, data, refetch, abort} = useFetch(validateFacebookBrand, testCase);
  return {
    status,
    data,
    refetch,
    abort,
  };
}

const testCases = getTestCases(mockValidateFacebookBrandsResponse);
testCases.set('invalid', (resolve, _reject) => {
  resolve(mockValidateFacebookBrandsResponseInvalid);
});

/**
  * @param {number} linkedAccountId
  * @param {string | undefined} brandId
  * @param {string} testCase
  * @param {AbortSignal} abortSignal
  * @return {!Promise<ValidateFacebookBrandResponse>}
  */
function validateFacebookBrand(linkedAccountId, brandId, testCase, abortSignal) {
  const businessId = window['businessId'];
  if (testCases.has(testCase)) {
    console.log(`mock validateFacebookBrand: businessId ${businessId} linkedAccountId ${linkedAccountId} brandId ${brandId} testCase ${testCase}`);
    return mockRequest(abortSignal, testCases.get(testCase));
  }
  const query = new Uri.QueryData;
  query.set('externalAccountId', linkedAccountId);
  query.set('brandPageId', brandId);

  const uri = new Uri(Routes.validateFacebookBrand()).setQueryData(query);

  return doRequest('validateFacebookBrand', abortSignal, uri, 'GET')
    .then(jsonResponse => ValidateFacebookBrandResponse.fromJSON(jsonResponse));
}


